import React, { HTMLProps } from "react";
import styled from "styled-components";

interface Props extends HTMLProps<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  questionIsOptional?: boolean;
}

const TextArea = styled.span<{ hasError: boolean }>`
  position: relative;
  display: block;

  .label {
    display: block;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.contentPrimary};
    font-size: ${({ theme }) => theme.font.size.label.one};
    font-family: Arial;
    margin-bottom: ${({ theme }) => theme.deprecatedSpacing.component.three};
  }

  .text-area {
    /* this is a hack to avoid chrome's auto-complete styling */
    transition: color 9999s ease-out, background-color 9999s ease-out;
    transition-delay: 9999s;

    box-sizing: border-box;
    width: 100%;
    background-color: ${({ theme }) => theme.deprecatedColors.white};
    vertical-align: middle;
    font-size: ${({ theme }) => theme.font.size.body.one};
    font-family: Arial;
    color: ${({ theme }) => theme.deprecatedColors.text.normal};
    border: 1px solid ${({ theme }) => theme.deprecatedColors.gray.six};
    border-radius: ${({ theme }) => theme.deprecatedSpacing.component.two};
    padding: 8px;
    border: 1px solid
      ${({ theme, hasError }) =>
        hasError ? theme.deprecatedColors.error : theme.deprecatedColors.gray.six};

    &:focus {
      border-color: ${({ theme }) => theme.deprecatedColors.primary.normal};
      outline-style: none;
    }
  }

  .errorText {
    display: block;
    color: ${({ theme, hasError }) =>
      hasError ? theme.deprecatedColors.error : theme.deprecatedColors.gray.six};
    font-size: ${({ theme }) => theme.font.size.body.three};
    line-height: ${({ theme }) => theme.font.size.body.two};
`;

export default function TextAreaInput({
  className,
  label,
  error,
  questionIsOptional = true,
  ...inputProps
}: Props) {
  return (
    <TextArea hasError={!!error} className={className}>
      {label && <label className="label">{label}</label>}
      <textarea className="text-area" {...inputProps} aria-required={!questionIsOptional} />
      {error && <span className="errorText">{error}</span>}
    </TextArea>
  );
}
